<template>

  <div>
    <v-toolbar
      flat
      color="white"
    >
      <!-- <v-text-field
        v-model="search"
        prepend-icon="search"
        label="Search"
        single-line
        hide-details
      ></v-text-field> -->

      <v-spacer></v-spacer>
      <v-btn
        @click="openSubtask"
        icon
      >
        <v-icon>add_circle_outline</v-icon>
      </v-btn>
      <v-dialog
        v-model="subdialog"
        max-width="800px"
      >

        <v-card>
          <!-- <v-toolbar
            card
            dense
            color="transparent"
          >
            <v-btn
              icon
              @click.native="close"
            >
              <v-icon>reply</v-icon>
            </v-btn>
            <v-btn
              icon
              @click.native="saveAndClose"
            >
              <v-icon>library_add</v-icon>
            </v-btn>

            <v-btn
              icon
              @click.native="save"
            >
              <v-icon>save</v-icon>
            </v-btn>
            <v-btn
              icon
              @click.native="add"
            >
              <v-icon>add</v-icon>
            </v-btn>
            <v-btn
              icon
              @click.native="deleterow"
            >
              <v-icon>delete</v-icon>
            </v-btn>

          </v-toolbar> -->
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <sub-task ref="refsubTaskForm"></sub-task>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary darken-1"
              outline
              @click.native="subdialog = false"
            >Cancel</v-btn>
            <v-btn
              color="primary darken-1"
              outline
              @click.native="saveSubTask"
            >Save</v-btn>
          </v-card-actions>
          <!-- <delete-confirmation-dialog
            ref="formdeleteConfirmationDialog"
            heading="Are You Sure You Want To Delete?"
            message="Are You Sure You Want To Delete This Item Permanently?"
            @onConfirm="formDeleteItem"
          >
          </delete-confirmation-dialog> -->
        </v-card>
      </v-dialog>
    </v-toolbar>

    <app-section-loader :status="subtaskloader"></app-section-loader>
    <v-data-table
      :items="subTaskitems"
      class="elevation-1"
      hide-actions
      hide-headers
    >
      <template
        slot="items"
        slot-scope="props"
      >
        <tr>
          <td>
            <v-btn icon>
              <v-icon>tune</v-icon>
            </v-btn>
          </td>
          <td>{{ props.item.title }}</td>
          <td>{{ props.item.workType }}</td>
          <td>{{ props.item.requestType }}</td>
          <td class="text-xs-right">{{ props.item.dueDate | formatDate}}</td>
          <td>
            <v-icon
              small
              class="mr-2"
              @click="showSubTask(props.item)"
            >
              edit
            </v-icon>

          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>
<script>

import SubTask from '@/pages/task/subtask';
import { getSubTasksId } from '@/api/taskMaster';

export default {
  components: {
    SubTask,
  },
  props: {
    type: {
      type: String,
      default: 'image'
    }
  },
  data: () => ({
    subtaskloader: false,
    size: 'lg',
    view: 'grid',
    folder: false,
    taskItems: [],
    subTaskitems: [],
    taskID: -1,
    maindescription: '',
    subdialog: false,
    formTitle: 'Sub Task',
    formdata: {
      valid: false,
      taskID: -1,
      date: new Date(),
      title: '',
      assignedTo: null,
      dueDate: new Date(),
      description: '',
      projectID: null,
      assignedCC: [],
      onBehalfID: null,
      sessionID: '',
      addedByUserID: 1,
      addedDate: new Date(),
      addedByUser: 'Arun',
      statusCodeID: 1,
      statusCode: 'Active',
      modifiedByUserID: 1,
      modifiedDate: new Date(),
      requiredfield: [v => !!v || 'This is required field'],
      tagMasterID: -1,
      tagIds: [],
      personaltagIds: [],
      addedByUser: 'Arun',
      attachments: [],
      documentID: -1,
      documentAccessID: null,
      documentAccessName: null,
      sessionID: null,
      linkID: null,
      isSpecialFile: true,
      isTemp: true,
      description: '',
      uploadedFile: null,
      onBehalfName: '',
      overDueAllowed: 'false',
      followUp: 'false',
    },
    subtasktriggered: false,
  }),
  computed: {

  },
  created () {
    // window.getApp.$on('INITIALIZE_SUBTASK', taskID => {
    //   if (!this.subtasktriggered) {
    //     this.subtasktriggered = true;
    //     this.taskID = taskID;
    //     this.initialize();
    //   }
    // });

    // window.getApp.$on('SEND_TASKOBJ', objTask => {
    //   this.formdata = objTask;
    // });

  },
  methods: {
    initialize () {
      if (this.taskID > 0) {

        this.subtaskloader = true;
        getSubTasksId(this.taskID)
          .then(response3 => {
            this.subTaskitems = response3.data;
            this.subtaskloader = false;
          })
          .catch(error => {
            this.subtaskloader = false;
            window.getApp.$emit('APP_API_ERROR', error);
          });
      }
      else {
        this.subTaskitems = [];
      }
    },
    formateDate (string) {
      return string ? new Date(string).toLocaleDateString() : '';
    },
    showSubTask (item) {

      setTimeout(() => {
        window.getApp.$emit('SEND_TASKOBJ', this.formdata);
        window.getApp.$emit('EDIT_SUBTASK', item);
      }, 300);
      this.subdialog = true;
    },
    openSubtask () {
      setTimeout(() => {
        window.getApp.$emit('SEND_TASKOBJ', this.formdata);
        let item = [];
        window.getApp.$emit('ADD_SUBTASK', this.taskID);
      }, 300);
      this.subdialog = true;
    },
    saveSubTask () {
      //  window.getApp.$emit('SAVE_SUBTASK', this.taskID);
    },
  }
};
</script>

<style lang="stylus" scoped>
.media {
  &-cotent--wrap, &-menu {
    min-width: 260px;
    border-right: 1px solid #eee;
    min-height: calc(100vh - 50px - 64px);
  }

  &-detail {
    min-width: 300px;
    border-left: 1px solid #eee;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/task/subTaskList.vue